// utils/auth-utils.js
export const checkAuthError = (error, navigate, showMessage = true) => {
    const isAuthError = 
      error?.response?.status === 401 || 
      error?.response?.status === 403 ||
      error?.message?.toLowerCase().includes('unauthorized') ||
      error?.message?.toLowerCase().includes('invalid token') ||
      error?.message?.toLowerCase().includes('token expired');
  
    if (isAuthError) {
      // 清除认证数据
      localStorage.removeItem('adminToken');
      localStorage.removeItem('user');
      
      const returnPath = window.location.pathname;
      
      // 添加消息通知
      if (showMessage) {
        navigate('/admin/login', { 
          state: { 
            from: { pathname: returnPath },
            authError: '您的登录已过期，请重新登录'
          },
          replace: true 
        });
      } else {
        navigate('/admin/login', { 
          state: { from: { pathname: returnPath } },
          replace: true 
        });
      }
      return true;
    }
    return false;
  };
  
  export const validateToken = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return false;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // 添加提前5分钟过期的检查，增加用户体验
      const isExpired = payload.exp && (Date.now() >= (payload.exp * 1000 - 5 * 60 * 1000));
      
      if (isExpired) {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('user');
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error validating token:', error);
      localStorage.removeItem('adminToken');
      localStorage.removeItem('user');
      return false;
    }
  };
  
  // 新增一个函数来检查令牌是否即将过期
  export const isTokenAboutToExpire = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) return true;
    
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      // 检查是否将在15分钟内过期
      return payload.exp && (Date.now() >= (payload.exp * 1000 - 15 * 60 * 1000));
    } catch (error) {
      return true;
    }
  };